import { SupportDeviceModel } from "../device-list-types";
import { BaseMapType } from "../map-types";

export enum SystemPlatform {
    STANDARD = "STANDARD",
    SCE = "SCE"
};

export type DeviceModelList = {
    [key in SupportDeviceModel]?: string;
};

export interface PlatformConfig {
    defaultBaseMapType: BaseMapType;
    baseMapOptions: BaseMapType[];
    simpleBaseMapOptions: BaseMapType[];
    geofenceEnable: boolean;
    menu_SUPPORT: boolean;
    menu_EMAILTEMPLATE: boolean;
    menu_AUDITLOGS: boolean;
    idleTimeoutRecovery: boolean;
    isReCaptchaEnable: boolean;
    isProfileAvatarSupported: boolean;
    encodeFileCheck: boolean;
    encodeAttribute: boolean;
    command_udpTest: boolean;
    command_backupSerialLog: boolean;
    command_capturePDNPacket: boolean;
    command_upgradeModule: boolean;
    device_webGui: boolean;
    device_ssh: boolean;
    config_gpsTracking: boolean;
    config_ttlHl: boolean;
    networkRemoteAccess: boolean;
    signalBreakThreshold: number;
    firmwareUploadByAdmin: boolean;
    logFileManagement: boolean;
    moduleFileManagement: boolean;
    deviceModelList: DeviceModelList;
    publicFileSpace: boolean;
    scheduler_UpgradeModuleTask: boolean;
    esim: boolean;
    inSystemPurchase: boolean;

};

export type PlatformConfigs = {
    [key in SystemPlatform]: PlatformConfig
};